import React, { useContext, useEffect, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, GridLegacy as Grid } from "@mui/material";
import { api, Category, CategoryType } from "../../../../../logic/api";
import propTypes from "prop-types";
import EditableGroup, { EditableGroupType } from "../../../EditableGroup/EditableGroup";
import { SessionContext } from "../../../../../utility/useSession";
import EditableField, { EditableFieldTypes } from "../../EditableField";
import ConfirmationDialog from "../../../../notifications/confirmationDialog/ConfirmationDialog";
import ErrorDialog from "../../../../notifications/errorDialog/ErrorDialog";
import { useTranslation } from "react-i18next";

const DistributionListCategoryDialog: React.FunctionComponent<{

    show: boolean;
    selected?: Category | null;
    onClose: (didUpdate: boolean, category: Category | null) => void;
}> = (props) => {

    const defaultCat = (props.selected == null ? {
        categoryName: "",
        id: 0,
        type: CategoryType.distribution,
    } as Category : props.selected) as Category;

    const [category, setCategory] = useState<Category>(defaultCat);

    useEffect(() => {
        setCategory(defaultCat);
    }, [props.selected]);

    const session = useContext(SessionContext);
    const isNew = category.id == 0;
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
    const createOrUpdate = api.hooks.category.ensure();
    const rename = api.hooks.category.rename();
    const deleteListAPI = api.hooks.distribution.deleteList();
    const { t } = useTranslation();

    const deleteList = (confirmed: boolean) => {
        if (confirmed == false) {
            setShowDeleteConfirmation(true);
            return;
        }
        if (props.selected == null) return;
        deleteListAPI.send(session.current.context, {
            categoryId: props.selected.id
        }, (result) => {
            if (result != null)
                props.onClose(true, null);
        });
    }

    const save = () => {
        if (isNew) {
            createOrUpdate.send(session.current.context, {
                name: category.categoryName,
                type: category.type,
            }, (result) => {
                if (result != null) {
                    setCategory(result);
                    props.onClose(true, result);
                }
            });
        } else {
            rename.send(session.current.context, {
                id: category.id,
                name: category.categoryName,

            }, (result) => {
                if (result != null) {
                    setCategory(result);
                    props.onClose(true, result);
                }
            });
        }

    }

    return <Dialog maxWidth="sm" fullWidth={true} open={props.show}>
        <DialogTitle>{isNew ? t("editable.createDistList") : t("editable.editDistList")}</DialogTitle>
        <DialogContent>
            <ErrorDialog err={deleteListAPI.err} />
            <ConfirmationDialog title={t("editable.deleteDistList")} message={t("editable.deleteDistListConfirm")} show={showDeleteConfirmation} onClose={(confirmed) => {
                if (confirmed == true) {
                    setShowDeleteConfirmation(false);
                    deleteList(true);
                }

            }}></ConfirmationDialog>
            <EditableGroup<Category>
                id="categorySettings"
                testId="distribution-category-group"
                editType={EditableGroupType.alwaysEditing}
                data={category}
                onDataChanged={async (data) => {
                    setCategory(data);
                    return true;
                }}
            >
                <Grid container>

                    <EditableField<Category, string>
                        inputType={EditableFieldTypes.text}
                        label={t("input.labels.name")}
                        onProvide={(data) => data.categoryName}
                        onChange={(data, value) => data.categoryName = value}
                    />
                </Grid>
            </EditableGroup>
        </DialogContent>
        <DialogActions>
            <Button color="inherit" onClick={() => {

                props.onClose(false, null);
            }}>{t("general.close")}</Button>
            {isNew == false && (
                <Button color="inherit" onClick={() => {
                    deleteList(false);
                }}>{t("general.delete")}</Button>
            )}
            <Button color="inherit" onClick={() => {
                save();
            }}>{t("general.save")}</Button>

        </DialogActions>
    </Dialog>;
}



DistributionListCategoryDialog.propTypes = {
    show: propTypes.bool.isRequired,
    selected: propTypes.any,
    onClose: propTypes.func.isRequired,
}

export default DistributionListCategoryDialog;